/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      // 获取自定义弹窗ID，如果没有则使用默认的
      this.panelId = this.dataset.panel || 'Product-Information-Drawer';
      this.drawer = document.getElementById(this.panelId);
      
      if (this.drawer) {
        this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
        this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      }
      
      this.body = document.body;
    }
    connectedCallback() {
      if (this.drawer) {
        this.setupObservers();
      }
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          if (this.buttons && this.buttons.toggleActiveClass) {
            this.buttons.toggleActiveClass(i);
          }
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}